import { schema } from 'normalizr';

export const groupValueSchema = new schema.Entity('groupValue');
